// Required by ng-bootstrap (i18n attributes → $localize at runtime).
import '@angular/localize/init';

// Node globals expected by dragula/crossvent and casbin in the browser.
// https://github.com/angular/angular-cli/issues/10305
// https://github.com/angular/angular-cli/issues/20819
(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
};

import { Buffer } from 'buffer';

(window as any).Buffer = (window as any).Buffer || Buffer;
